import "./styles.scss";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { postFormReport } from "../../store/middleware";

function ErrorReportForm() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [form, setForm] = useState({
    comment: "",
    contentId: "",
    classFocus: "Regular",
    sequentialScheduleId: "",
  });

  const onSubmit = async () => {
    if (!form.comment) return alert("Please enter a comment");
    if (!form.contentId) return alert("Please enter a content");
    if (!form.classFocus) return alert("Please enter a class");
    if (!form.sequentialScheduleId) return alert("Please enter a sequential schedule");

    await dispatch(postFormReport(form))
      .then((resp) => {
        if (resp) {
          alert("Report sent successfully");
          setForm({ comment: "", contentId: "", classFocus: "Regular", sequentialScheduleId: "" });
        }
      })
      .catch((error) => alert(error.response.data.error));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    if (name === "classFocus" && value === "Specific") {
      setForm({ ...form, contentId: "null" });
    }
  };

  return (
    <div className="errorReportForm">
      <div>
        <label>Sequential Schedule ID</label>
        <input type="text" name="sequentialScheduleId" value={form.sequentialScheduleId} onChange={handleChange} />
      </div>

      <div>
        <label>Class Focus</label>
        <select name="classFocus" value={form.classFocus} onChange={handleChange}>
          <option value="Regular">{t("BTN_REGULAR")}</option>
          <option value="Specific">{t("BTN_SPECIFIC")}</option>
        </select>
      </div>

      <div>
        <label>
          Content ID <span>{`- add the ids separated by commas ","`}</span>
        </label>
        <input type="text" name="contentId" value={form.contentId} onChange={handleChange} />
      </div>

      <div>
        <label>Comment</label>
        <textarea type="text" name="comment" value={form.comment} onChange={handleChange} />
      </div>

      <button type="submit" onClick={onSubmit}>
        Send
      </button>
    </div>
  );
}

export default ErrorReportForm;
